import { call, put, takeLatest, takeEvery, delay, select } from 'redux-saga/effects';

import userService from '../../../services/UserService';

import {
	getUsers,
	getUsersSuccess,
	getUsersFailure,
	getCurrentUser,
	getCurrentUserFailure,
	getCurrentUserSuccess,
	editCurrentUser,
	editCurrentUserFailure,
	editCurrentUserSuccess,
	getUserById,
	getUserByIdSuccess,
	getUserByIdFailure,
	createUser,
	createUserSuccess,
	createUserFailure,
	updateUser,
	updateUserSuccess,
	updateUserFailure,
	removeUser,
	removeUserSuccess,
	removeUserFailure,
	getUserTypes,
	getUserTypesSuccess,
	getUserTypesFailure,
	getModals,
	getModalsSuccess,
	getModalsFailure,
	setCurrentBaseId,
	setCurrentBaseIdSuccess,
	downloadCsv,
	downloadCsvFailure,
	downloadCsvSuccess,
} from '.';

function* rootSaga() {
	yield takeLatest(getUsers, getUsersSaga);
	yield takeLatest(getCurrentUser, getCurrentUserSaga);
	yield takeLatest(editCurrentUser, editCurrentUserSaga);
	yield takeLatest(getUserById, getUserByIdSaga);
	yield takeEvery(createUser, createUserSaga);
	yield takeLatest(updateUser, updateUserSaga);
	yield takeEvery(removeUser, removeUserSaga);
	yield takeLatest(getUserTypes, getUserTypesSaga);
	yield takeLatest(getModals, getModalsSaga);
	yield takeLatest(setCurrentBaseId, setCurrentBaseIdSaga);
	yield takeLatest(downloadCsv, downloadCsvSaga);
}

function* getUsersSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(userService.getAll, payload);
		yield put(getUsersSuccess(response));
	} catch (error) {
		yield put(getUsersFailure(error));
	}
}

function* getCurrentUserSaga({ payload }) {
	try {
		yield delay(300);
		const currentUser = yield call(userService.getCurrentUser);
		yield put(getCurrentUserSuccess(currentUser));
	} catch (error) {
		yield put(getCurrentUserFailure(error));
	}
}

function* editCurrentUserSaga({ payload }) {
	try {
		const editedUser = yield call(userService.updateMe, payload);
		yield put(editCurrentUserSuccess(editedUser));
	} catch (error) {
		yield put(editCurrentUserFailure(error));
	}
}

function* getUserByIdSaga({ payload }) {
	try {
		yield delay(300);
		const user = yield call(userService.get, payload);
		yield put(getUserByIdSuccess(user));
	} catch (error) {
		yield put(getUserByIdFailure(error));
	}
}

function* createUserSaga({ payload }) {
	try {
		const createdUser = yield call(userService.create, payload);
		yield put(createUserSuccess(createdUser));
		const tableParams = yield select(({ users }) => users.users.tableParams);
		yield put(getUsers(tableParams));
	} catch (error) {
		yield put(createUserFailure(error));
	}
}

function* updateUserSaga({ payload }) {
	const { userId: id, data: userForm } = payload;
	try {
		yield delay(300);
		const response = yield call(userService.update, id, userForm);
		yield put(updateUserSuccess(response));

		// Refreshing the users list since we edited one:
		const tableParams = yield select(({ users }) => users.users.tableParams);
		yield put(getUsers(tableParams));
	} catch (error) {
		yield put(updateUserFailure(error));
	}
}

function* removeUserSaga({ payload }) {
	const id = payload;
	try {
		yield delay(300);
		const removedUser = yield call(userService.remove, id);
		yield put(removeUserSuccess(removedUser));

		// Refreshing the users list since we removed one:
		const tableParams = yield select(({ users }) => users.users.tableParams);
		yield put(getUsers(tableParams));
	} catch (error) {
		yield put(removeUserFailure(error));
	}
}

function* getUserTypesSaga({ payload }) {
	try {
		yield delay(300);
		const userTypes = yield call(userService.getUserTypes);
		yield put(getUserTypesSuccess(userTypes));
	} catch (error) {
		yield put(getUserTypesFailure(error));
	}
}

function* getModalsSaga({ payload }) {
	try {
		yield delay(300);
		const modals = yield call(userService.getModals);
		yield put(getModalsSuccess(modals));
	} catch (error) {
		yield put(getModalsFailure(error));
	}
}

function* setCurrentBaseIdSaga({ payload }) {
	try {
		yield delay(300);
		yield put(setCurrentBaseIdSuccess(payload));
	} catch (error) {
		console.log('Failed to set setCurrentBaseId in saga', error);
	}
}

function* downloadCsvSaga({ payload }) {
	try {
		yield delay(300);
		yield call(userService.downloadCsv, payload);
		yield put(downloadCsvSuccess());
	} catch (error) {
		yield put(downloadCsvFailure(error));
	}
}

export default rootSaga;
